module.exports = __webpack_public_path__ + "img/verivox.9f63102e.png";